// src/components/HowItWorks.jsx
//
// Requiere en public/index.html (dentro de <head>), para la tipografía serif del número:
// <link rel="preconnect" href="https://fonts.googleapis.com">
// <link rel="preconnect" href="https://fonts.gstatic.com" crossOrigin="true">
// <link href="https://fonts.googleapis.com/css2?family=Fraunces:opsz,wght@9..144,500;9..144,600&display=swap" rel="stylesheet">
//
// Si prefieres no tocar index.html, quita la clase font-['Fraunces'] de abajo
// y el número caerá en la tipografía sans por defecto del proyecto.

import { useTranslation, Trans } from "react-i18next";

const STEPS = [
  { number: "1", key: "zipcode" },
  { number: "2", key: "booking" },
  { number: "3", key: "products" },
  { number: "4", key: "pickup" },
];

// Pasa la función que abre tu modal de zipcode, ej:
// <HowItWorks onOpenZipcodeModal={() => setZipcodeModalOpen(true)} />
export default function HowItWorks({ onOpenZipcodeModal }) {
  const { t } = useTranslation();

  return (
    <section className="bg-[#EFE6DD] py-16 sm:py-28">
      <div className="mx-auto max-w-7xl px-4 sm:px-6 lg:px-8">
        {/* Encabezado */}
        <div className="mx-auto max-w-2xl text-center">
          <span className="text-xs font-semibold uppercase tracking-[0.2em] text-[#9A0002]">
            {t("howItWorks.eyebrow")}
          </span>
          <h2 className="mt-3 text-3xl font-semibold tracking-tight text-[#3A2A20] sm:text-4xl">
            {t("howItWorks.title")}
          </h2>
          <p className="mt-4 text-base leading-7 text-[#3A2A20]/70">
            {t("howItWorks.subtitle")}
          </p>
        </div>

        {/* Correa punteada que conecta los 4 pasos: vertical en móvil, horizontal en desktop */}
        <div className="relative mt-12 sm:mt-16">
          <div
            aria-hidden="true"
            className="pointer-events-none absolute left-0 right-0 top-9 hidden border-t-2 border-dashed border-[#9A0002]/25 lg:block"
          />

          <ol className="grid grid-cols-1 gap-8 sm:grid-cols-2 sm:gap-10 lg:grid-cols-4 lg:gap-6">
            {STEPS.map((step, i) => (
              <li
                key={step.key}
                className="relative flex items-start gap-5 text-left sm:flex-col sm:items-center sm:gap-0 sm:text-center"
              >
                {/* Tramo vertical de la correa hacia el siguiente paso (solo móvil) */}
                {i < STEPS.length - 1 && (
                  <div
                    aria-hidden="true"
                    className="absolute left-8 top-16 -bottom-8 border-l-2 border-dashed border-[#9A0002]/25 sm:hidden"
                  />
                )}

                {/* Medallón numerado, estilo llavero de habitación */}
                <div className="relative z-10 flex h-16 w-16 shrink-0 items-center justify-center rounded-full border-2 border-[#9A0002] bg-[#9A0002] shadow-[0_0_0_6px_#EFE6DD] sm:h-[72px] sm:w-[72px]">
                  <span className="font-['Fraunces'] text-2xl font-semibold text-[#EFE6DD]">
                    {step.number}
                  </span>
                </div>

                <div className="pt-2 sm:pt-0">
                  <h3 className="text-lg font-semibold text-[#3A2A20] sm:mt-6 sm:text-base">
                    {t(`howItWorks.steps.${step.key}.title`)}
                  </h3>
                  <p className="mt-1.5 text-[15px] leading-6 text-[#3A2A20]/70 sm:mx-auto sm:mt-2 sm:max-w-[220px] sm:text-sm">
                    {step.key === "zipcode" ? (
                      <Trans
                        i18nKey="howItWorks.steps.zipcode.description"
                        components={{
                          1: (
                            <button
                              type="button"
                              onClick={onOpenZipcodeModal}
                              className="font-medium text-[#9A0002] underline underline-offset-2 hover:text-[#7A0001]"
                            />
                          ),
                        }}
                      />
                    ) : (
                      t(`howItWorks.steps.${step.key}.description`)
                    )}
                  </p>
                </div>
              </li>
            ))}
          </ol>
        </div>
      </div>
    </section>
  );
}